export class SearchResultsPageState {

  resultsVisible = true;
  areaSearchVisible = false;

}
